import { render, staticRenderFns } from "./NewsEditComponent.vue?vue&type=template&id=cf9abc34&scoped=true&"
import script from "./NewsEditComponent.vue?vue&type=script&lang=js&"
export * from "./NewsEditComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsEditComponent.vue?vue&type=style&index=0&id=cf9abc34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9abc34",
  null
  
)

export default component.exports